
export const isAlbumError = state => state.music.album.error;

export const isSongError = state => state.music.song.error;

export const getRecommendations = state => state.music.recommendations;

export const getTopten = state => state.music.songs.popular && state.music.songs.popular;

export const getLatests = state => state.music.songs.latests && state.music.songs.latests;

export const getPopularPodcasts = state => state.music.podcasts.popular;

export const getLatestPodcasts = state => state.music.podcasts.latests;

export const getLoadedAlbum = state => state.music.album;

export const getLoadedSong = state => state.music.song;
